export const digit = (value) => {
  if (!value) return '0';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const throttled = (fn, delay = 1500) => {
  let lastCall = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return null;
    }
    lastCall = now;
    return fn(...args);
  };
};

export const debounced = (fn, delay = 300) => {
  let timerId;
  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
};

export const groupBy = (arr, key) =>
  arr.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});

export const hideLoading = () => {
  document.getElementById('loading').style.display = 'none';
};

export const showLoading = (delay = 0) => {
  document.getElementById('loading').style.display = 'block';

  if (delay > 0) {
    setTimeout(() => {
      hideLoading();
    }, delay);
  }
};

export const rnd = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

export const uuidv4 = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const capitalize = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const removeDuplicate = (list, key) => {
  const newList = [...list];
  for (let i = newList.length - 1; i > 0; i--) {
    for (let j = i - 1; j >= 0; j--) {
      if (newList[i][key] === newList[j][key]) {
        newList.splice(i, 1);
        break;
      }
    }
  }
  return newList;
};
